import CardHeader from '../../components/CardHeader.vue';
import CourseCard from './../../components/SpocCourseCard.vue';
import { Empty } from 'zhs-components';
export default {
  props: {
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number,
      default: 0
    }
  },
  components: {
    CourseCard,
    CardHeader,
    Empty
  },

  created() {
    this.getAuth();
    console.log(this.authType);
    this.getFilterList();
  },

  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      classId: undefined,
      authType: 0,
      classifyList: [],
      // 分类列表
      classifyId: null
    };
  },

  methods: {
    async getHomeCourseList() {
      const homeCourse = await this.$http.getHomeSpoc({
        num: this.menu.num,
        menu_id: this.menu.menu_id,
        classify_id: this.classifyId
      });
      this.homeCourseList = homeCourse || [];
    },

    async getAuth() {
      const res2 = await this.$http.getConfigList();
      this.authType = res2.find(item => item.code == '10402') ? res2.find(item => item.code == '10402').auth_type : 0;
    },

    // 获取核心素养的过滤列表
    async getFilterList() {
      let params = {
        course_type: "2",
        classify_id: '',
        menu_id: this.menu.menu_id
      };
      const res = await this.$http.getFilterList(params);
      console.log('筛选列表', res);
      this.classifyList = res.classify_list.filter(item => item.name !== '全部');
      this.classifyId = this.classifyList[0].id;
      this.getHomeCourseList();
    },

    // 点击核心素养筛选
    searchCourseList(id) {
      this.classifyId = id;
      this.getHomeCourseList();
    }

  }
};